module.exports = __webpack_public_path__ + "img/auto-best-odds.72c7b030.svg";